/**
 * @function resetMessageHandler - Function to reset the Auth context message
 * @param setState - hook to set the Auth context state
 */
export const resetMessageHandler = setState => {
  setState(prevState => ({
    ...prevState,
    message: { text: "", variant: "" },
  }))
}
